export const APP_BRAND_NAME = "Ultralight";
export const APP_LEGAL_ENTITY_NAME = "Vibrant Practice, Inc.";
export const APP_SUPPORT_EMAIL = "help@ultralighthealth.com";

export const APP_BRAND_ASSETS = {
  greyWordmark: "/images/ultralight-logo-grey-wordmark.svg",
  whiteWordmark: "/images/ultralight-logo-white-wordmark.svg",
  // Raster logomark in brand orange (#f16b03) — SVG is unreliable in email clients (Gmail strips it).
  orangeLogomark: "/images/ultralight-logo-orange-logomark.png",
  poweredBy: "/images/powered-by-ultralight.png",
} as const;

export const APP_BRAND_ALT_TEXT = {
  wordmark: "Ultralight logo",
  logomark: "Ultralight logo mark",
  poweredBy: "Powered by Ultralight",
} as const;

export const APP_LEGAL_LINKS = {
  privacy: "https://www.ultralighthealth.com/clinical-app-privacy-policy",
  terms: "https://www.ultralighthealth.com/clinical-app-terms-of-use",
} as const;

export const APP_MARKETING_SITE_URL = "https://www.ultralighthealth.com/";

export const APP_SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/ultralighthealth/",
  linkedin: "https://www.linkedin.com/company/ultralighthealth/",
  twitter: "https://x.com/ultralight_ai",
} as const;
